import { MonitoringSetupErrorSchema } from '../schemas/projectMonitoring'
import { useState } from 'react'
import { AgentPromptBox } from './AgentPrompt'
import { useGetMonitoringSetupQuery } from '../services/sessionMonitoringApi'

export default function ProjectMonitoringSetup({ projectId }: { projectId: string }) {
  const query = useGetMonitoringSetupQuery(projectId)
  const [copied, setCopied] = useState(false)
  const [copyError, setCopyError] = useState(false)
  const credential = query.currentData
  const instructions = credential ? `Set up Self Healing for my app using Replay QA project ${projectId}.

Install @replayio/self-healing-capture@0.1.8 and its @fullstory/browser peer dependency using the app's package manager. Initialize capture before rendering the app UI. Inspect any existing recorder first and replace its initialization rather than installing a second recorder:

import { initCapture } from '@replayio/self-healing-capture';
const capture = initCapture(${JSON.stringify({ publishableKey: credential.key, ...(new URL(credential.endpoint).origin !== 'https://qa.replay.io' ? { serviceUrl: new URL(credential.endpoint).origin } : {}) }, null, 2)});

Keep the controller for capture.identify(user), capture.flush(), and capture.stop(). The publishable upload key above is ready to use. Do not add an application backend forwarding route, fetch a configuration document, or import qa-monitoring-v1.js. The package sends captures directly to QA. The upstream @fullstory/browser SDK loads FullStory's recorder from its CDN. If the app uses CSP, allow https://edge.fullstory.com in script-src and the QA origin in connect-src. Preserve FullStory masking and privacy rules.


Open the app, interact with it, and verify that a real session reaches this project. Explain anything still requiring my action. Leave project onboarding unchanged.` : ''
  return <div className="monitoring-setup">
    <p>Give these instructions to the coding agent working on your app.</p>
    {query.isLoading && <p role="status">Preparing setup instructions…</p>}
    {query.isError && <p role="alert">{MonitoringSetupErrorSchema.safeParse(query.error).data?.data.error ?? 'Self-healing setup is unavailable.'} <button onClick={() => void query.refetch()}>Retry</button></p>}
    {credential && <div className="fs-mask"><AgentPromptBox prompt={instructions} copied={copied} analyticsEvent="self-healing-setup-prompt-copy" onCopy={() => {
      setCopyError(false)
      void navigator.clipboard.writeText(instructions).then(() => setCopied(true)).catch(() => setCopyError(true))
    }} /></div>}
    {copyError && <p role="alert">Could not copy. Select and copy the prompt above.</p>}
  </div>
}
